module.exports = __webpack_public_path__ + "static/media/co.32331dff.svg";